import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dbDate',
})
export class DbDatePipe implements PipeTransform {
    transform(data: string): string {
        try {
            if (data.trim()) {
                return moment(data.trim()).format('DD/MM/YYYY');
            } else {
                return 'Não Possui';
            }
        } catch (error) {
            return '';
        }
    }
}
